import 'babel-polyfill';
import 'core-js/es6/promise';
import 'core-js/fn/object/entries';
import 'core-js/fn/string/includes';
import 'core-js/fn/string/starts-with';
import 'url-search-params-polyfill';
import 'isomorphic-fetch';

import React from 'react';
import ReactDOM from 'react-dom';
import Raven from 'raven-js';

// Your top level component
import App from './App';

// Export your top level component as JSX (for static rendering)
export default App;

// Render your app
if (typeof document !== 'undefined') {
    if (process.env.NODE_ENV === 'production') {
        function getCookie(sKey) {
            if (!sKey) {
                return null;
            }
            return document.cookie.replace(new RegExp('(?:(?:^|.*;)\\s*' + sKey.replace(/[\-\.\+\*]/g, '\\$&') + '\\s*\\=\\s*([^;]*).*$)|^.*$'), '$1') || null;
        }

        try {
            // eslint-disable-next-line max-params
            ((m, e, t, r, i, k, a) => {
                m[i] = m[i] || function() {
                    (m[i].a = m[i].a || []).push(arguments);
                };
                m[i].l = 1 * new Date();
                k = e.createElement(t);
                a = e.getElementsByTagName(t)[0];
                k.async = 1;
                k.src = r;

                if (getCookie('consent') === 'true') {
                    console.log('yandex', 'cookie consent found');
                    a.parentNode.insertBefore(k, a);
                } else {
                    window.addEventListener('cookieconsent', () => {
                        console.log('yandex', 'cookie consent granted');
                        a.parentNode.insertBefore(k, a);
                    });
                }

            })(window, document, 'script', 'https://mc.yandex.ru/metrika/tag.js', 'ym');

            ym(55690873, 'init', {
                id: 55690873,
                clickmap: true,
                trackLinks: true,
                accurateTrackBounce: true,
                webvisor: true
            });
        } catch (error) {
        }

        Raven.config('https://2ab17546029d48cc862d65e3ac702a30@sentry.io/1774689', {
            maxMessageLength: 512,
            ignoreUrls: [
                /graph\.facebook\.com/i,
                /connect\.facebook\.net\/en_US\/all\.js/i,
                /eatdifferent\.com\.woopra-ns\.com/i,
                /static\.woopra\.com\/js\/woopra\.js/i,
                /extensions\//i,
                /^chrome:\/\//i,
                /^opera:\/\//i,
                /127\.0\.0\.1:4001\/isrunning/i,
                /webappstoolbarba\.texthelp\.com\//i,
                /metrics\.itunes\.apple\.com\.edgesuite\.net\//i
            ],
            ignoreErrors: [
                'top.GLOBALS',
                'originalCreateNotification',
                'canvas.contentDocument',
                'MyApp_RemoveAllHighlights',
                'http://tt.epicplay.com',
                'Can\'t find variable: ZiteReader',
                'jigsaw is not defined',
                'ComboSearch is not defined',
                'http://loading.retry.widdit.com/',
                'atomicFindClose',
                'fb_xd_fragment',
                'bmi_SafeAddOnload',
                'EBCallBackMessageReceived',
                'conduitPage'
            ]
        }).install();
    }

    const renderMethod = module.hot ? ReactDOM.render : ReactDOM.hydrate || ReactDOM.render;

    const render = Comp => {
        renderMethod(<Comp/>, document.getElementById('root'));
    };

    // Render!
    render(App);
}



// WEBPACK FOOTER //
// /Users/stephan/skelware/savot/src/index.js